// extracted by mini-css-extract-plugin
module.exports = {"hidden":"Embaixador_hidden__8gdTY","loading":"Embaixador_loading__1YA-w","content":"Embaixador_content__223XD","section_button":"Embaixador_section_button__3b9Y1"};